export default {
  en: {
    navigation: {
      about: "About",
      milestones: "Milestones",
      skills: "Skills",
      portfolio: "Portfolio",
    },
    about: {
      title: "About",
      introduction:
        "An engineer that mainly focuses on web development, specifically ReactJS. Consider myself a frontend engineer, but have interest in a variety of different domains such as: Backend, Database, CI/CD, Test/Integration, System Administration, security, App development. I like to make products and being fascinating by the process of iterating and gradually optimizing an useful product, thus one of my life goal is to build a product that can make an impact to the majority.",
      interests: {
        title: "Interests",
        0: "Any web-related technology, especially frontend & backend",
        1: "Development flow, DevOps、CI/CD",
        2: "Arduino and some basic MCU",
        3: "Write Lean, high readability, efficient code",
        4: "Anime, movie, American series",
        5: "Guitar 🎸",
      },
      contactMe: "Contact Me",
    },
    milestones: {
      title: "Milestones",
    },
    skills: {
      title: "Skills",
      degrees: {
        average: "average",
        fair: "fair",
      },
      category: {
        language: "Programming Language",
        devops: "DevOps",
        database: "Database",
        backend: "Backend",
        frontend: "Frontend",
        design: "Design",
        mobile: "Mobile",
        misc: "MISC",
      },
    },
    portfolio: {
      portfolio: "Portfolio",
      fanPage: "Fan Page",
    },
  },
  zh: {
    navigation: {
      about: "關於我",
      milestones: "學經歷",
      skills: "工作技能",
      portfolio: "作品集",
    },
    about: {
      title: "關於我",
      introduction:
        "專攻網頁前端開發的工程師，主力使用的工具是 ReactJS。雖然以前端工程師自居，但是對於後端、資料庫、CI/CD、測試整合、系統管理、資安、App 開發也有涉獵。喜歡做產品，對於逐步迭代、打造出可以使用的產品的這個過程十分著迷，也以可以做出影響世界的產品自許。",
      interests: {
        title: "個人興趣",
        0: "跟網頁前、後端有關的任何技術",
        1: "開發流程、DevOps、自動化部屬/測試",
        2: "略懂 Arduino 跟一些基礎 MCU",
        3: "寫出簡潔、高可讀性、高效能的程式碼",
        4: "動畫、電影、日劇，美劇",
        5: "吉他 🎸",
      },
      contactMe: "聯繫我",
    },
    milestones: {
      title: "學經歷",
    },
    skills: {
      title: "工作技能",
      category: {
        language: "程式語言",
        devops: "開發維運",
        database: "資料庫",
        backend: "後端",
        frontend: "前端",
        design: "設計",
        mobile: "行動裝置",
        misc: "其他",
      },
    },
    portfolio: {
      portfolio: "作品集",
      fanPage: "粉絲專頁",
    },
  },
};
